var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"section-settings-group",attrs:{"sentry-tag":"settings-panel"}},[_c('div',{staticClass:"section__entry mb-2 mb-md-0"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.description))])]),_c('div',{staticClass:"section__box"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }